import { gsap } from 'gsap'
import { deepMerge } from 'js/utils/Utils'
import BaseJsHover from 'js/modules/_base/events/mouse/hover/BaseJsHover'

const defaults = {
  instanceName: 'banner2Hover',
  $names: {
    target: '[data-js-hover=banner2]',
    icon: '.career_first_btn_icon',
  },
  styleInfo: {
    colorHovered: '#f1f1f1',
    colorDefault: '#0d0d0d',
    bgColorHovered: '#0d0d0d',
    bgColorDefault: '#ceff00',
    iconColorHovered: '#0d0d0d',
    iconColorDefault: '#ceff00',
    iconBgColorHovered: '#ceff00',
    iconBgColorDefault: '#0d0d0d',
  },
}

export default class Banner2Hover extends BaseJsHover {
  constructor(options = {}) {
    super()
    deepMerge(this, defaults, options)
  }

  async _enterAnimation($target, num) {
    await new Promise((resolve) => {
      if ($target) {
        gsap.killTweensOf($target, ['backgroundColor', 'color'])
        gsap.to($target, {
          color: this.styleInfo.colorHovered,
          backgroundColor: this.styleInfo.bgColorHovered,
          duration: 0.55,
          ease: 'cubic.out',
        })

        const $icon = $target.querySelector(this.$names.icon)
        if ($icon) {
          gsap.killTweensOf($icon, ['backgroundColor', 'color'])
          gsap.to($icon, {
            color: this.styleInfo.iconColorHovered,
            backgroundColor: this.styleInfo.iconBgColorHovered,
            duration: 0.55,
            delay: 0.025,
            ease: 'cubic.out',
          })
        }
      }

      gsap.delayedCall(0.4, () => {
        resolve()
      })
    })
  }

  async _leaveAnimation($target, num) {
    await new Promise((resolve) => {
      const $inner = $target.querySelector(this.$names.inner)
      if ($target) {
        gsap.killTweensOf($target, ['backgroundColor', 'color'])
        gsap.to($target, {
          color: this.styleInfo.colorDefault,
          backgroundColor: this.styleInfo.bgColorDefault,
          duration: 0.75,
          delay: 0.05,
          ease: 'cubic.out',
        })

        const $icon = $target.querySelector(this.$names.icon)
        if ($icon) {
          gsap.killTweensOf($icon, ['backgroundColor', 'color'])
          gsap.to($icon, {
            color: this.styleInfo.iconColorDefault,
            backgroundColor: this.styleInfo.iconBgColorDefault,
            duration: 0.75,
            delay: 0.05,
            ease: 'cubic.out',
          })
        }
      }

      resolve()
    })
  }
}